import { render, staticRenderFns } from "./DocumentsDelivery.vue?vue&type=template&id=ad1474f4&scoped=true"
import script from "./DocumentsDelivery.vue?vue&type=script&lang=js"
export * from "./DocumentsDelivery.vue?vue&type=script&lang=js"
import style0 from "./DocumentsDelivery.vue?vue&type=style&index=0&id=ad1474f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad1474f4",
  null
  
)

export default component.exports